import { useExportContext } from '@contexts/ExportContext';
import { ExportStateData } from '@hooks/useExportState';
import { EntityTypeEnum, ExportColumnInDTO, ExportFormatEnum } from '@api/ringil-api.v2';

interface UseExportJobResult {
  activeExports: Record<string, ExportStateData>;
  /** `columns`: export these columns (a v3 tab's) instead of the entity's fixed set; null = the fixed set, sent explicitly. */
  startExport: (entityType: EntityTypeEnum, entityLabel: string, filter: unknown, exportFormat: ExportFormatEnum, columns?: ExportColumnInDTO[] | null) => void;
  cancelExport: (jobId: string) => void;
  resetAll: () => void;
}

/**
 * Hook to access export state and actions.
 * Supports multiple concurrent exports.
 * 
 * Uses the centralized export state management via ExportContext
 * which handles:
 * - Polling intervals per jobId
 * - localStorage persistence (multi-tab sync)
 * - Smart 409 conflict detection
 * - Download handling
 * 
 * All components using this hook share the same state instance via ExportProvider.
 */
export function useExportJob(): UseExportJobResult {
  const exportState = useExportContext();
  
  return {
    activeExports: exportState.activeExports,
    startExport: exportState.startExport,
    cancelExport: exportState.cancelExport,
    resetAll: exportState.resetAll,
  };
}
